import { useEffect, useState } from "react";
import { Smartphone } from "lucide-react";
import { Modal } from "./Modal";
import { useAuth } from "../auth/AuthContext";
import {
  dismissPhoneBindNudge,
  isPhoneBindNudgeDismissed,
} from "../auth/phoneBindNudgeStorage";
import { usePersonalCenter } from "../data/PersonalCenterContext";

/** 每次登录会话：未绑手机则弹一次；可跳过，下次登录再弹 */
export function PhoneBindNudge() {
  const { needsPhoneBind, phoneBound } = useAuth();
  const { openPersonalCenter } = usePersonalCenter();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (phoneBound === true) {
      setOpen(false);
      return;
    }
    if (!needsPhoneBind || phoneBound !== false) {
      setOpen(false);
      return;
    }
    if (isPhoneBindNudgeDismissed()) {
      setOpen(false);
      return;
    }
    setOpen(true);
  }, [needsPhoneBind, phoneBound]);

  const dismiss = () => {
    dismissPhoneBindNudge();
    setOpen(false);
  };

  const goBind = () => {
    dismiss();
    openPersonalCenter({ phoneBind: true });
  };

  return (
    <Modal
      open={open}
      title="建议绑定手机号"
      eyebrow="账号安全"
      onClose={dismiss}
    >
      <div className="phone-bind-nudge">
        <span className="phone-bind-nudge-icon" aria-hidden>
          <Smartphone size={28} strokeWidth={1.6} />
        </span>
        <p>
          当前微信账号尚未绑定手机号。绑定后可用短信验证码登录，也便于找回与通知。
        </p>
        <p className="muted">
          可暂时跳过，稍后在个人中心 → 安全 中绑定。每次登录会再次提醒。
        </p>
        <div className="phone-bind-nudge-actions">
          <button type="button" className="btn btn-primary" onClick={goBind}>
            去绑定
          </button>
          <button type="button" className="btn btn-ghost" onClick={dismiss}>
            暂时跳过
          </button>
        </div>
      </div>
    </Modal>
  );
}
